import * as React from "react";
import PropTypes from "prop-types";
import Theme from "./Theme";

const ButtonGroup = ({ children }) => (
  <div
    data-component-name="ButtonGroup"
    style={{
      width: "100%",
      ...Theme.Styles.flexLayout,
    }}
  >
    {React.Children.toArray(children).map((button, index, all) => {
      let style = { ...button.props.style };
      Object.assign(style, Theme.Styles.flexStretchEqual);

      if (all.length !== 1) {
        const borderRadius = style.borderRadius || Theme.Button.RADIUS;
        style.borderRadius = "";

        const borderRule = "1px solid rgba(0, 0, 0, 0.15)";

        if (index === 0) {
          // first button
          Object.assign(style, {
            borderTopLeftRadius: borderRadius,
            borderBottomLeftRadius: borderRadius,
            borderRight: borderRule,
          });
        } else if (index + 1 === all.length) {
          // last button
          Object.assign(style, {
            borderTopRightRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
            borderLeft: borderRule,
          });
        } else {
          // middle buttons
          Object.assign(style, {
            borderLeft: borderRule,
            borderRight: borderRule,
          });
        }
      }

      return React.cloneElement(button, { style });
    })}
  </div>
);
ButtonGroup.propTypes = {
  children: PropTypes.node,
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ../nx-components/src/ButtonGroup.jsx